module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-BOOSTER-GREEN-1.d8b35b1b.jpg";